<template>
  <div class="row">
    <div v-for="(userScore, index) in scores" v-bind:key="userScore.userId" class="col-12 col-lg-4">
      <span v-if="index > 0">
        #{{index}} <span class="player">{{userScore.username}}</span><br />
        Score: {{userScore.total}}pts<br />
        <span v-if="scores[0].total > 0">
          Pourcentage du top: {{Number(userScore.total * 100 / scores[0].total).toFixed(2)}}%
        </span>
        <span v-else>
          Pourcentage du top: 100%
        </span>
      </span>
      <span v-else>
        <span class="player">TOP</span><br />
        Score : {{userScore.total}}pts <br />
        vous ne pourrez faire mieux
      </span>
      <table class="table table-stripped table-sm">
        <thead>
          <tr>
            <th>Tour</th>
            <th>Mot joué</th>
            <th></th>
            <th>Score</th>
          </tr>
        </thead>
        <tbody v-for="score in userScore.scores" v-bind:key="score.roundNumber">
          <tr>
            <td>#{{score.roundNumber}}</td>
            <td>{{score.reference}}</td>
            <td><img src="/static/star.svg" class="star"
                v-if="index > 0 && isTop(score.roundNumber, score.score)"
                title="TOP !"/></td>
            <td class="text-end">
              <span class="bonus"
                title="Bonus pour être le seul joueur à marquer ce super score"
                v-if="score.bonus">
                  BONUS +{{score.bonus}}</span>
              {{score.score}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PlayerGameSheet',
  props: {
    scores: {
      type: Array,
      required: true,
    },
  },
  methods: {
    isTop(roundNumber, score) {
      return this.scores[0].scores
        .findIndex(s => s.roundNumber === roundNumber && s.score === score) >= 0;
    },
  },
};
</script>

<style scoped>
div{
  font-size: 0.8rem;
}
span{
  font-size: 1rem;
}
.player{
  font-size: 1rem;
  color: #CE0F69;
}
img.star {
  width: 14px;
}
.bonus {
  font-size: 0.70rem;
  color: #CE0F69;
}
</style>
